// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"1093517c","297":"7cf36e31","345":"bedc2690","686":"1473af74","798":"d72941dc","915":"9559944e"}[chunkId] + ".chunk.css";
};